import './ApiKeyGenerator.scss';

import {CopyOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, message, Tooltip, Typography} from 'antd';
import React, {useState} from 'react';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import currentUserService from '../../../services/user/currentUserService.js';
import {truncateKey} from '../../../utils/truncateKey.js';

const {Text} = Typography;

const FormApiKeyGenerator = ({value, onChange, userId}) => {
    const [isLoading, setIsLoading] = useState(false);
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();

    const handleGenerateKey = async () => {
        if (!userId) {
            message.error('ID користувача не знайдено.');
            return;
        }
        setIsLoading(true);
        try {
            await currentUserService.generateApiKey({
                userId,
                onRequestSuccess: (data) => {
                    onChange?.(data.apiKey);
                },
            });
        } catch {
            message.error('Не вдалося створити ключ.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCopyKey = () => {
        navigator.clipboard.writeText(value);
        message.success('Ключ скопійовано!');
    };

    if (isMobile) {
        return (
            <div className='ep-form-item-api-key-mobile'>
                {value ? (
                    <div className='user-api-key-value'>
                        <code>{truncateKey(value)}</code>
                        <button
                            type='button'
                            onClick={handleCopyKey}
                            aria-label={strings[localizationKeys.USERS_MOBILE_COPY_API_KEY]}
                        >
                            <CopyOutlined aria-hidden />
                        </button>
                    </div>
                ) : (
                    <Button loading={isLoading} onClick={handleGenerateKey} icon={<PlusOutlined aria-hidden />}>
                        {strings[localizationKeys.USERS_MOBILE_CREATE_API_KEY]}
                    </Button>
                )}
            </div>
        );
    }

    return (
        <div className='ep-form-item-api-key-wrapper'>
            {!value ? (
                <Button
                    type='primary'
                    icon={<PlusOutlined />}
                    loading={isLoading}
                    onClick={handleGenerateKey}
                    className='ep-form-item-api-key-btn'
                >
                    Створити API Key
                </Button>
            ) : (
                <div className='ep-form-item-api-key-display'>
                    <Text style={{fontSize: 16}}>{truncateKey(value)}</Text>
                    <Tooltip title='Копіювати ключ'>
                        <CopyOutlined
                            onClick={handleCopyKey}
                            style={{
                                marginLeft: 'auto',
                                cursor: 'pointer',
                                color: 'var(--color-primary)',
                            }}
                        />
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

export default FormApiKeyGenerator;
